import { EnvironmentTwoTone } from '@ant-design/icons';
import type React from 'react';
import type { ReactElement } from 'react';

export interface MarkerProps {
  lat: number;
  lng: number;
  icon?: ReactElement;
  containerStyle?: React.CSSProperties;
  size?: number;
  padding?: number;
  onClick?: () => void;
}

export const Marker: React.FC<MarkerProps> = ({
  icon,
  containerStyle = {},
  size = 30,
  padding = size / 3,
  onClick,
}) => {
  const renderedIcon = icon ?? <EnvironmentTwoTone />;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  const interactiveProps = onClick
    ? {
        onClick,
        onKeyDown: handleKeyDown,
        role: 'button' as const,
        tabIndex: 0,
      }
    : {};

  return (
    <div
      {...interactiveProps}
      style={{
        fontSize: size,
        transition: 'all .2s',
        transform: 'translate(-50%, -50%)',
        background: '#fff',
        width: size + padding * 2,
        height: size + padding * 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: size / 2 + padding,
        boxShadow: '0 0 5px #0004',
        cursor: onClick ? 'pointer' : 'default',
        ...containerStyle,
      }}
    >
      {renderedIcon}
    </div>
  );
};
